<p-panel>
    <div class="container-fluid gap-5">
        <div class="row">
            <div class="col">
                <app-reactive-form-builder
                    #builderRef
                    (stableValueChanges)="stableValueChanges($event)"
                    (internalLifecycleEvents)="onReactiveFormLifecycleEvent($event)"
                    (afterSend)="onAfterSend($event)"
                    (goBack)="goBack()"
                    [form]="form.formFields"
                    [serverUrl]="form.env.serverUrl"
                    [id]="(getModel().id)?.toString() ?? ''"
                    [request]="this.getType() === 1 ? this.stockApi.entradas.PUT : this.stockApi.entradas.POST"
                    [getRequest]="this.stockApi.entradas.GET">
                </app-reactive-form-builder>
            </div>
        </div>
    </div>
</p-panel>
